import { useCallback, useEffect, useMemo, useState } from "react";

import {
    Activate_Rest_Menu_Restaurant_Item_Customization_Put,
    Activate_Restaurant_Item_Customization_Put,
    All_Restaurant_Item_Customization_List_Post,
    DeActivate_Rest_Menu_Restaurant_Item_Customization_Put,
    DeActivate_Restaurant_Item_Customization_Put,
    Delete_Rest_Menu_Restaurant_Item_Customization_Delete,
    Delete_Restaurant_Item_Customization_Delete,
    Deleted_Restaurant_Item_Customization_List_POST,
    Revive_Rest_Menu_Restaurant_Item_Customization_Put,
    Revive_Restaurant_Item_Customization_Put,
} from "api/ApiConst";
import { handleActive, handleDelete, handleInactive, handleRevive } from "utils/UserUtils";

import CheckboxButton from "components/common/CheckboxButton";
import PaginationDataTable from "components/common/PaginationDataTable";
import CustomButton from "components/common/CustomButton";
import PageHeading from "components/common/PageHeading";
import RestaurantItemCustomizationAddEdit from "./RestaurantItemCustomizationAddEdit";

const RestaurantItemCustomizationMaster = () => {
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [viewDeletedList, setViewDeletedList] = useState(false);
    const [recordID, setRecordID] = useState(null);
    const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);
    const [restaurantKeyValuePairs, setRestaurantKeyValuePairs] = useState([]);
    const [ownedItem, setOwnedItem] = useState(true)

    useEffect(() => {
        if (!showAddUpdateModal) {
            setRecordID(null);
            setOwnedItem(true);
        }
    }, [showAddUpdateModal]);

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const columns = useMemo(
        () => [
            {
                id: "status",
                name: "",
                selector: (row) => {
                    if (row.active) {
                        return <div className="led-green" title="Active" />;
                    } else {
                        return <div className="led-red" title="Inactive" />;
                    }
                },
                width: "60px",
                sortable: false,
            },
            {
                id: "title",
                name: "Title",
                selector: (row) => (<span className="parent-owned-flag">
                    {row.owned && <span className="badge bg-primary owned-flag" title="Owned">O</span>} {" "}
                    {row.title}
                </span>),
                sortable: false,
            },
            {
                id: "customizationType",
                name: "Customization Type",
                selector: (row) => row.customizationType,
                sortable: false,
            },
            // {
            //     id: "minMaxSelection",
            //     name: "min < max Selection",
            //     selector: (row) => row.minimumSelection + " < " + row.maximumSelection,
            //     sortable: false,
            // },
            {
                id: "action",
                name: "",
                selector: (row) => getActionButtons(row),
                width: "120px",
            },
        ],
        [handleRefresh]
    );

    const getActionButtons = (row) => {
        return (
            <div className="d-flex align-items-center justify-content-between">
                {!row.deleted && (
                    <button className="listBtn me-2" onClick={() => handleEdit(row)}>
                        <i className="bx bx-pencil"></i>
                    </button>
                )}
                <div className="dropdown">
                    <button className="btn btn-primary btn-flat btn-addon btn-xs dropdown-toggle" title="More" data-bs-toggle="dropdown" aria-expanded="false" style={{ padding: "5px 10px 8px 10px" }}>
                        <i className="bx bx-chevron-down"></i>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right">
                        <>
                            {row.deleted ? (
                                <li onClick={() => handleReviveData(row)}>
                                    <i className="bx bx-log-out-circle"></i> Revive
                                </li>
                            ) : (
                                <>
                                    <li onClick={() => handleDeleteData(row)}>
                                        <i className="bx bx-trash"></i> Delete
                                    </li>
                                    <li onClick={() => handleActiveInactive(row)}>
                                        {row.active ? (
                                            <>
                                                <i className="bx bx-x-circle"></i> Inactive
                                            </>
                                        ) : (
                                            <>
                                                <i className="bx bx-check-circle"></i> Active
                                            </>
                                        )}
                                    </li>
                                </>
                            )}
                        </>
                    </ul>
                </div>
            </div>
        );
    };

    const handleEdit = (row) => {
        setRecordID(row.uuid);
        setOwnedItem(row.owned)
        setShowAddUpdateModal(true);
    };

    const handleActiveInactive = (row) => {
        if (row.active) {
            const rUrl = row.owned ? DeActivate_Restaurant_Item_Customization_Put : DeActivate_Rest_Menu_Restaurant_Item_Customization_Put;
            handleInactive(rUrl.replaceAll("{recordID}", row.uuid), handleRefresh);
        } else {
            const rUrl = row.owned ? Activate_Restaurant_Item_Customization_Put : Activate_Rest_Menu_Restaurant_Item_Customization_Put;
            handleActive(rUrl.replaceAll("{recordID}", row.uuid), handleRefresh);
        }
    };

    //Delete Record
    const handleDeleteData = (row) => {
        const rUrl = row.owned ? Delete_Restaurant_Item_Customization_Delete : Delete_Rest_Menu_Restaurant_Item_Customization_Delete;
        handleDelete(rUrl.replaceAll("{recordID}", row.uuid), handleRefresh);
    };

    //Revive Record
    const handleReviveData = (row) => {
        const rUrl = row.owned ? Revive_Restaurant_Item_Customization_Put : Revive_Rest_Menu_Restaurant_Item_Customization_Put
        handleRevive(rUrl.replaceAll("{recordID}", row.uuid), handleRefresh);
    };

    const handleToggleDeletedView = () => setViewDeletedList(!viewDeletedList);
    return (
        <>
            {PageHeading("Item Customization List", "Dashboard", "/")}
            <div className="card">
                <CustomButton handleClick={() => setShowAddUpdateModal(true)} title="Create New" iconClass="bx bx-plus" buttonClass="createButton" />
                <div className="card-body tableView">
                    <PaginationDataTable
                        paginationUrl={viewDeletedList ? Deleted_Restaurant_Item_Customization_List_POST : All_Restaurant_Item_Customization_List_Post}
                        serverSidePagination={false}
                        search={true}
                        pagination={false}
                        columns={columns}
                        filterColumn={"title"}
                        filter={true}
                    />
                    <CheckboxButton title="Deleted List" handleClick={handleToggleDeletedView} additionalClass="deletedBtn ml-auto" />
                </div>
            </div>
            {showAddUpdateModal && (
                <RestaurantItemCustomizationAddEdit
                    show={showAddUpdateModal}
                    hideModal={() => setShowAddUpdateModal(false)}
                    recordID={recordID}
                    handleRefresh={handleRefresh}
                    restaurantKeyValuePairs={restaurantKeyValuePairs}
                    ownedItem={ownedItem}
                />
            )}
        </>
    );
};

export default RestaurantItemCustomizationMaster;
